
export class Option {
  static LogicNodeHeight = 280
  static LogicNodeWidth = 336
  static LogicNodeShape = 'logic-node'
  static deviceNodeShape = 'device-node'
}